<script>
import configure from '@/tools/configurator/configure'
import sensarTools from '@/tools/project/sensar'
import store from '@/store'
import dialogcommercial from 'Components/dialog-commercial'

export default {
  name: 'sensaroption',
  components: {
    dialogcommercial
  },
  props: {
    optionname: String
  },
  computed: {
    sensar () {
      return store.getters['sensar/getItemByName'](this.optionname)
    },
    gradientImage () {
      return process.env.BASE_URL + 'assets/gradient.jpg'
    },
    currentframe: {
      get: function () {
        return this.sensar.currentframe
      },
      set: function (newValue) {
        if (newValue < this.sensar.startframe) {
          newValue = this.sensar.endframe
        } else if (newValue > this.sensar.endframe) 
        {
          newValue = this.sensar.startframe
        }
        this.date = this.allowedDates[newValue]
        this.pressure = this.sensar.deformation[newValue].pressure
        sensarTools.SetDisplacementFrame(this.sensar.deformation[newValue], this.deformationValue, this.sensar.deformationmultiplier);
        if (this.switch1) sensarTools.SetAlbedoFrame(this.sensar.deformation[newValue]);
        store.commit('sensar/updatePropertyOfItemByName', {itemName: this.sensar.name, property: 'currentframe', value: newValue })
      }
    },
    deformationValue: {
      get: function () {
        return this.deformationVal
      },
      set: function (newValue) {
        if (newValue < this.deformationMin) {
          newValue = this.deformationMax
        } else if (newValue > this.deformationMax) 
        {
          newValue = this.deformationMin
        }
        this.deformationVal = newValue
      }
    },
    speedValue: {
      get: function () {
        return this.speedVal
      },
      set: function (newValue) {
        if (newValue < this.speedMin) {
          newValue = this.speedMax
        } else if (newValue > this.speedMax) 
        {
          newValue = this.speedMin
        }
        this.speedVal = newValue
      }
    },
    switch1: {
      get: function () {
        return this.switch
      },
      set: function (newValue) {
        this.switch = newValue
        if (newValue === false) {
          const material = store.state.material.all[0]
          const option = material.options.find(option => option.name === material.visible)
          configure.SetMaterialOption(material, option)
          sensarTools.SetDisplacementFrame(this.sensar.deformation[this.currentframe], this.deformationValue,this.sensar.deformationmultiplier);
        } else {
          sensarTools.SetDisplacementFrame(this.sensar.deformation[this.currentframe], this.deformationValue,this.sensar.deformationmultiplier);
          sensarTools.SetAlbedoFrame(this.sensar.deformation[this.currentframe]);
        }
      }
    }        
  },
  data: () => ({
      // currentframe: 0,
      deformationMin: 0,
      deformationMax: 25,
      deformationVal: 15,
      speedMin: 1,
      speedMax: 25,
      speedVal: 10,
      date: '',
      pressure: '',
      dateMin: '',
      dateMax: '',
      allowedDates: [],
      show: true,
      switch: false,
      tour: null
  }),
  mounted () {
    this.currentframe = this.sensar.currentframe
    this.speedValue = this.sensar.playbackspeed
    this.allowedDates = this.sensar.deformation.map(item => item.date)
    this.dateMin = this.allowedDates[0]
    this.dateMax = this.allowedDates[this.allowedDates.length-1]
    this.date = this.dateMin
    this.play()

    this.tour = this.$shepherd({
      useModalOverlay: true,
      exitOnEsc: true,
      defaultStepOptions: {
        cancelIcon: {
          enabled: true
        },
        scrollTo: { behavior: 'smooth', block: 'center' }
      }          
    });

    this.tour.addStep({
      title: '4D model',
      attachTo: { element: '.player', on: 'auto'},
      text: 'This 4D model shows the effect of Land Subsidence over time. Drag the mouse or swipe your finger to orbit around the model. Scroll or pinch to zoom in or out.',
      buttons: [{
        text: 'Next',
        action: this.tour.next
      }]
    });
    this.tour.addStep({
      title: 'Play/Pause',
      attachTo: { element: '.timebuttons', on: 'auto'},
      text: 'Play or pause the animation',
      buttons: [{
        text: 'Back',
        action: this.tour.back
      },{
        text: 'Next',
        action: this.tour.next
      }]
    });
    this.tour.addStep({
      title: 'Time slider',
      attachTo: { element: '.timeslider', on: 'auto'},
      text: 'Drag the slider to see land subsidence data on different dates. Note that the subsidence is relative to the first image.',
      buttons: [{
        text: 'Back',
        action: this.tour.back
      },{
        text: 'Next',
        action: this.tour.next
      }]
    });
    this.tour.addStep({
      title: 'Time and place',
      attachTo: { element: '.timeplaceshortcuts', on: 'auto'},
      text: 'These are shortcuts to a specific place. Zoom in on these locations where the Land Subsidence is clearly visible.',
      buttons: [{
        text: 'Back',
        action: this.tour.back
      },{
        text: 'Next',
        action: this.tour.next
      }]
    });
    this.tour.addStep({
      title: 'Imagery',
      attachTo: { element: '.textureswitch', on: 'auto'},
      text: 'Switch between an RGB Satellite image or a deformation map which further illustrates the amount of Land Subsidence.',
      buttons: [{
        text: 'Back',
        action: this.tour.back
      },{
        text: 'Next',
        action: this.tour.next
      }]
    });
    this.tour.addStep({
      title: 'Scale',
      attachTo: { element: '.deformationscale', on: 'auto'},
      text: 'Exaggerate the scale of the deformation. Note that the displayed deformation is always exaggerated (even with scale 1), the maximum deformation is around 8 centimeters.',
      buttons: [{
        text: 'Back',
        action: this.tour.back
      },{
        text: 'Next',
        action: this.tour.next
      }]
    });
    this.tour.addStep({
      title: 'Speed',
      attachTo: { element: '.deformationspeed', on: 'auto'},
      text: 'Change the speed of the deformation animation',
      buttons: [{
        text: 'Back',
        action: this.tour.back
      },{
        text: 'Let\'s go!',
        action: this.tour.complete
      }]
    });

    //make sure the bottom nav is expanded, otherwise the tour can't proceed
    store.commit('ui/updateItemByName', {key: 'bottomnav', value: true})
    this.tour.start();
  },
  methods: {
    play () {
        store.dispatch('sensar/clearInterval')

        let self = this
        const interval = setInterval(function() {
          self.currentframe++
        }, 1000/self.speedValue);

        store.dispatch('sensar/setInterval', {interval: interval})
    },
    pause () {
      store.dispatch('sensar/clearInterval')
    },
    skipBackward () {
      this.currentframe = this.sensar.startframe
      store.dispatch('sensar/clearInterval')
    },
    skipPrevious () {
      this.currentframe--
      store.dispatch('sensar/clearInterval')
    },
    skipForward () {
      this.currentframe = this.sensar.endframe
      store.dispatch('sensar/clearInterval')
    },
    skipNext () {
      this.currentframe++
      store.dispatch('sensar/clearInterval')
    },
    setAnimationSpeed () {
      if (store.state.sensar.interval !== null) {
        this.pause()
        this.play()
      }
    },
    setDate (value) {
      const index = this.allowedDates.findIndex(item => item === value)
      this.currentframe = index
      this.pause()
    },
    setPlaceAndTime (time, annotationIdx) {
      // this.setDate(time)
      configure.gotoAnnotation(annotationIdx)
    },
    isDateAllowed (value) {
      return this.allowedDates.indexOf(value) !== -1
    },
    openDialog () {
      store.commit('ui/updateItemByName', {key: 'projectsdialog', value: true})
    }    
  }  
}
</script>

<template>
<v-card 
  color="cardaccent"
  flat
>

  <div class="ml-3 pt-6 timebuttons">
    <v-btn class="mx-2 playpause" rounded dark color="primary" @click="pause">
      Pause <v-icon class="playpauseicon" large >mdi-pause</v-icon>
    </v-btn>
    <v-btn class="mx-2 playpause" rounded dark color="primary" @click="play">
      Play <v-icon class="playpauseicon" large >mdi-play</v-icon>
    </v-btn>
  </div>

  <v-row class="mx-2">
    <v-col cols="12" >
      <v-slider
        class="timeslider"
        label="Date"
        :min="sensar.startframe"
        :max="sensar.endframe"
        v-model="currentframe"
        @start="pause"
      >
        <template v-slot:append>
          <v-text-field
            v-model="date"
            class="mt-0 pt-0"
            hide-details
            single-line
            readonly
            type="string"
            style="width: 100px"
          ></v-text-field>
        </template>
      </v-slider>    
    </v-col>

    <v-col cols="12" class="py-0">
      <div class="text-subtitle-1 font-weight-light text--secondary">Show the land subsidence at a specific place</div>
      <v-list color="cardaccent" class="timeplaceshortcuts">
        <v-list-item two-line @click="setPlaceAndTime('2019-05-21',0)">
          <v-list-item-content>
            <v-list-item-title>District 1: The city center</v-list-item-title>
          </v-list-item-content>
        </v-list-item>          
        <v-list-item two-line @click="setPlaceAndTime('2019-08-13',1)">
          <v-list-item-content>
            <v-list-item-title>District 2: The new business district </v-list-item-title>
          </v-list-item-content>
        </v-list-item>          
        <v-list-item two-line @click="setPlaceAndTime('2018-12-08',2)">
          <v-list-item-content>
            <v-list-item-title>The new metro-line</v-list-item-title>
          </v-list-item-content>
        </v-list-item>          
      </v-list>
      <v-divider></v-divider>
    </v-col>

    <v-col cols="12" class="py-0 textureswitch">
    <v-list-item >
      <v-switch v-model="switch1" :label="`Show deformation map`"></v-switch>
      </v-list-item>

      <v-sheet
        v-if=switch1
        class="legend_gradient"
        height=30
      > </v-sheet>    
      <div
        v-if=switch1
        class="mt-2 d-flex justify-space-between text--secondary font-weight-light text-body-2"
      >
        <div>-50</div>
        <div>-40</div>
        <div>-30</div>
        <div>-20</div>
        <div>-10</div>
        <div>0</div>
        <div>10</div>
        <div>20</div>
        <div>30</div>
        <div>40</div>
        <div>50</div>
      </div>   
      <div
        v-if=switch1
        class="mt-1 mb-3 text--secondary font-weight-light text-body-2"
      >
        Deformation in millimeters
      </div>   
    </v-col>

    <v-col cols="12">
      <v-slider
      class="deformationscale"
        label="Scale"
        :min="deformationMin"
        :max="deformationMax"
        v-model="deformationValue"
      >
        <template v-slot:append>
          <v-text-field
            v-model="deformationValue"
            class="mt-0 pt-0"
            hide-details
            single-line
            type="number"
            style="width: 45px"
          ></v-text-field>
        </template>
      </v-slider>    
    </v-col>

    <v-col cols="12">
      <v-slider
      class="deformationspeed"
        label="Speed(fps)"
        :min="speedMin"
        :max="speedMax"
        v-model="speedValue"
        @end="setAnimationSpeed"
      >
        <template v-slot:append>
          <v-text-field
            v-model="speedValue"
            @click="setAnimationSpeed"
            class="mt-0 pt-0"
            hide-details
            single-line
            type="number"
            style="width: 45px"
          ></v-text-field>
        </template>
      </v-slider>
    </v-col>
  </v-row>

    <v-divider></v-divider>
  <v-card-actions>
    <v-btn class="text--secondary replaybutton" text tile @click="tour.start()">
      Replay Tour
    </v-btn>
    <v-btn class="text--secondary replaybutton" text tile @click.stop="openDialog()">
      Read more
    </v-btn>
    <dialogcommercial/>
  </v-card-actions>
</v-card>

</template>

<style lang="scss" scoped>
@import '../styles/shepherd.css';
  .playpause {
    border-radius: 28px !important;
    margin-right: 0px !important;
    min-width: 64px !important;
    box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12) !important;
    font-size: 0.875rem !important;    
    font-weight: 500 !important;
    text-transform: uppercase !important;
    color:rgba(255, 255, 255, 1) !important;
  }
  .replaybutton {
    margin-right: 0px !important;
    min-width: 130px !important;
    height: 44px !important;
    font-size: 0.875rem !important;
    font-weight: 500 !important;
    text-transform: uppercase !important;
  }
  .playpauseicon {
    margin-right: 0px !important;
    color:rgba(255, 255, 255) !important;
  }
  .replayicon {
    margin-right: 8px !important;
    margin-left: 4px !important;
  }
  .legend_gradient {
    background-image: linear-gradient(to right, #8F0600, #FDD700, #31CE34, #00C2A5, #000090);
  }
</style>